<form #ngForm="ngForm" nz-form [formGroup]="form" [nzLayout]="'inline'">
    <p *ngIf="element.label" style="text-align: left; margin-bottom: 0;">
        {{ element.label }}
    </p>

    <nz-form-item *ngFor="let field of fields" [style]="'max-width: 100%;'">
        <nz-form-label
            [style]="field.type === 'boolean' ? 'order: 1;' : 'order: 0;'"
            *ngIf="field.label"
            [nzNoColon]="field.type === 'boolean'"
            [nzFor]="field.id"
            [nzRequired]="field.required"
            style="white-space: normal;"
            >{{ field.label }}</nz-form-label
        >

        <nz-form-control
            [style]="field.type === 'boolean' ? 'order: 0;' : 'order: 1;'"
            nzErrorTip="Error"
        >
            <label
                *ngIf="field.type === 'boolean'; else inputTmp"
                class="check"
                nz-checkbox
                [formControlName]="field.id"
            ></label>
            <ng-template #inputTmp>
                <input
                    *ngIf="field.type === 'string' || field.type === 'number'"
                    nz-input
                    [type]="field.type"
                    [formControlName]="field.id"
                    [id]="field.id"
                />
            </ng-template>
        </nz-form-control>
    </nz-form-item>
</form>
